const inicialState = {
  cishFinalizada: false, 
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/cish/cish.state.js